import { render, staticRenderFns } from "./AreYouReady.vue?vue&type=template&id=3b32788f&scoped=true&"
import script from "./AreYouReady.vue?vue&type=script&lang=js&"
export * from "./AreYouReady.vue?vue&type=script&lang=js&"
import style0 from "./AreYouReady.vue?vue&type=style&index=0&id=3b32788f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b32788f",
  null
  
)

export default component.exports